import { useState, useEffect, forwardRef } from "react";
import { useTheme } from "next-themes";
import { EyeAltIcon, EyeIcon, ReceiptIcon } from "./icons";
import { numberWithCommas } from "../utils/numbers";
import useWindowSize from "../hooks/useWindowSize";

const RequestItem = forwardRef(({ data, utils, toggleProofModal, toggleDetailsModal, investAmount, action, t }, ref) => {
  const [offerRate, setOfferRate] = useState();

  const screenSize = useWindowSize();

  // const calculatedUnits = data?.offer_price ? (investAmount ? (investAmount / parseFloat(data.offer_price)).toFixed(2) : '') : '0';

  // // console.log(calculatedUnits, typeof calculatedUnits);
  // let unitsWithComma = '';

  // if (calculatedUnits !== '' && calculatedUnits !== '0') {
  // 	const { whole, decimal } = utils.separate(calculatedUnits);

  // 	unitsWithComma = numberWithCommas(whole) + '.' + decimal;
  // } else if (calculatedUnits === '0' && investAmount !== '') {
  // 	unitsWithComma = "0.0"
  // } else if (investAmount === '') {
  // 	unitsWithComma = ''
  // }

  const { theme } = useTheme();

  // const nav = utils.separate(parseFloat(data.navData.nav).toFixed(2));
  // const offer = utils.separate(parseFloat(data.offer_price).toFixed(2));
  // const repurchase = utils.separate(parseFloat(data.redemption_price).toFixed(2));
  // const outstanding = utils.separate(parseFloat(data.outstanding_units).toFixed(2));
  // const face = utils.separate(parseFloat(data.face_value).toFixed(2));
  // const one_year = utils.separate(data.one_year);

  return (
    <div className='col-12 p-0 animate-card' ref={ref ?? ref} style={{
        // width: screenSize >= 576 ? '' : '570px'
    }}>
      <div className='row w-100 mx-auto align-items-center text-start py-1 flex-nowrap gap-1 gap-sm-3 gap-lg-5'>
        <div className='col-2 col-sm-2 col-md-2 col-lg-2 p-0 px-1 ps-1 pe-1 pe-sm-4'>
          <div
            className='text-truncate'
            style={{
              fontSize: screenSize >= 992 ? "1.5rem" : screenSize >= 768 && screenSize <= 991 ? "1.4rem" : screenSize >= 576 && screenSize <= 767 ? "1.35rem" : "1.25rem",
              lineHeight: "1",
              fontWeight: "500",
              // display: '-webkit-box',
              // boxOrient: 'vertical',
              // WebkitBoxOrient: 'vertical',
              // WebkitLineClamp: '3',
              overflow: "hidden",
              color: theme === "dark" ? "var(--theme-light-secondary)" : "var(--theme-light-primary)",
            }}
          >
            {data.fund_code}
          </div>
          <div
            className=''
            style={{
              // fontSize: screenSize >= 576 ? "0.78rem" : ".70rem",
              fontSize: screenSize >= 992 ? ".78rem" : screenSize >= 768 && screenSize <= 991 ? ".72rem" : screenSize >= 576 && screenSize <= 767 ? ".68rem" : ".625rem",
              letterSpacing: ".02em",
              fontWeight: "400",
              lineHeight: "1",
              color: theme === "dark" ? "rgba(255,255,255,.6)" : "var(--theme-light-secondary)",
              marginTop: "4px",
              display: "-webkit-box",
              boxOrient: "vertical",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: "2",
              overflow: "hidden",
            }}
          >
            {data.fund_name || ""}
          </div>
        </div>
        <div className='col-2 col-sm-1 col-md-auto p-0 px-1'>
          <div className=''>
            <div
              className='text-start'
              style={{
                minWidth: screenSize >= 992 ? "130px" : screenSize >= 768 && screenSize <= 991 ? "105px" : "",
                display: "inline-block",
              }}
            >
              <div
                className=''
                style={{
                  // fontSize: screenSize <= 991 ? "0.6rem" : "0.74rem",
                  fontSize: screenSize >= 992 ? "0.7rem" : screenSize <= 991 && screenSize >= 576 ? "0.7rem" : "0.6rem",
                  fontWeight: "400",
                  color: `rgba(${theme === "dark" ? "var(--theme-dark-tertiary)" : "var(--theme-light-tertiary)"},0.5)`,
                  letterSpacing: ".05em",
                }}
              >
                {t("requests.item.type")}
              </div>
              <div
                className=''
                style={{
                  // fontSize: screenSize <= 991 ? "1.1rem" : "1.14rem",
                  fontSize: screenSize >= 992 ? "1.15rem" : screenSize <= 991 && screenSize >= 768 ? "1.1rem" : screenSize <= 767 && screenSize >= 576 ? "1.05rem" : ".95rem",
                  fontWeight: "400",
                  lineHeight: "1.1",
                  // minHeight: screenSize <= 575 ? '17.6px' : '',
                  color: `rgba(${theme === "dark" ? "var(--theme-dark-tertiary), 0.8" : "var(--theme-light-tertiary), 0.75"})`,
                  marginTop: screenSize <= 991 ? "2px" : "2px",
                }}
              >
                {data.request_type === "saleofunit" ? "Invest" : data.request_type === "redemptionofunits" ? "Redeem" : "Convert"}
              </div>
            </div>
          </div>
        </div>
        <div
          className='col-2 col-sm col-md-2 col-lg-1 p-0 px-1'
          style={{
            width: screenSize <= 575 ? "18%" : "",
          }}
        >
          <div className=''>
            <div
              className='text-right-fixed'
              style={{
                minWidth: screenSize >= 576 ? "76px" : "",
                // display: "inline-block",
              }}
            >
              <div
                className=''
                style={{
                  // fontSize: screenSize <= 991 ? "0.6rem" : "0.74rem",
                  fontSize: screenSize >= 992 ? "0.7rem" : screenSize <= 991 && screenSize >= 576 ? "0.7rem" : "0.6rem",
                  fontWeight: "400",
                  color: `rgba(${theme === "dark" ? "var(--theme-dark-tertiary)" : "var(--theme-light-tertiary)"},0.5)`,
                  letterSpacing: ".05em",
                }}
              >
                {t("requests.item.units")}
              </div>
              <div
                className=''
                style={{
                  // fontSize: screenSize <= 991 ? "1.1rem" : "1.14rem",
                  fontSize: screenSize >= 992 ? "1.15rem" : screenSize <= 991 && screenSize >= 768 ? "1.1rem" : screenSize <= 767 && screenSize >= 576 ? "1.05rem" : ".95rem",
                  fontWeight: "400",
                  lineHeight: "1.1",
                  color: `rgba(${theme === "dark" ? "var(--theme-dark-tertiary), 0.8" : "var(--theme-light-tertiary), 0.75"})`,
                  marginTop: screenSize <= 991 ? "2px" : "2px",
                }}
              >
                {numberWithCommas(data.units_requested)}
              </div>
            </div>
          </div>
        </div>
        <div className='col-2 col-sm p-0 px-1'>
          <div className=''>
            <div
              className='text-right-fixed'
              style={{
                minWidth: screenSize >= 576 ? "76px" : "58px",
                // display: "inline-block",
              }}
            >
              <div
                className=''
                style={{
                  // fontSize: screenSize <= 991 ? "0.6rem" : "0.74rem",
                  fontSize: screenSize >= 992 ? "0.7rem" : screenSize <= 991 && screenSize >= 576 ? "0.7rem" : "0.6rem",
                  fontWeight: "400",
                  color: `rgba(${theme === "dark" ? "var(--theme-dark-tertiary)" : "var(--theme-light-tertiary)"},0.5)`,
                  letterSpacing: ".05em",
                }}
              >
                {t("requests.item.amount")}
              </div>
              <div
                className=''
                dir="ltr"
                style={{
                  // fontSize: screenSize <= 991 ? "1.1rem" : "1.14rem",
                  fontSize: screenSize >= 992 ? "1.15rem" : screenSize <= 991 && screenSize >= 768 ? "1.1rem" : screenSize <= 767 && screenSize >= 576 ? "1.05rem" : ".95rem",
                  fontWeight: "400",
                  lineHeight: "1.1",
                  color: `rgba(${theme === "dark" ? "var(--theme-dark-tertiary), 0.8" : "var(--theme-light-tertiary), 0.75"})`,
                  marginTop: screenSize <= 991 ? "2px" : "2px",
                  wordBreak: 'break-all'
                }}
              >
                <span
                dir="ltr"
                  style={{
                    fontSize: screenSize >= 992 ? "0.78rem" : screenSize <= 991 && screenSize >= 576 ? "0.78rem" : "0.65rem",
                    marginRight: '.25rem',
                    color: theme === "dark" ? "rgba(210, 124, 216, .86)" : "rgba(16, 109, 221, .76)",
                  }}
                >
                  {t("app.fund.rupee")}
                </span>
                {numberWithCommas(data.gross_amount_limit)}
                {/* <span style={{
									fontSize: screenSize >= 992 ? ".965rem" : (screenSize <= 991 && screenSize >= 576) ? "0.965rem" : ".95rem"
								}}>
									{(nav.whole === '0' && nav.decimal === '00') ? '' : nav.decimal}
								</span> */}
              </div>
            </div>
          </div>
        </div>
        <div className='col-2 col-sm p-0 px-1'>
          <div className='d-flex align-items-center justify-content-md-start'>
            <div
              className='text-start'
              style={{
                minWidth: screenSize >= 576 ? "76px" : "58px",
                display: "inline-block",
              }}
            >
              <div
                className=''
                style={{
                  // fontSize: screenSize <= 991 ? "0.6rem" : "0.74rem",
                  fontSize: screenSize >= 992 ? "0.7rem" : screenSize <= 991 && screenSize >= 576 ? "0.7rem" : "0.6rem",
                  fontWeight: "400",
                  color: `rgba(${theme === "dark" ? "var(--theme-dark-tertiary)" : "var(--theme-light-tertiary)"},0.5)`,
                  letterSpacing: ".05em",
                }}
              >
                {t("requests.item.status")}
              </div>
              <div
                className=''
                style={{
                  // fontSize: screenSize <= 991 ? "1.1rem" : "1.14rem",
                  fontSize: screenSize >= 992 ? "1.15rem" : screenSize <= 991 && screenSize >= 768 ? "1.1rem" : screenSize <= 767 && screenSize >= 576 ? "1.05rem" : ".95rem",
                  fontWeight: "400",
                  lineHeight: "1.1",
                  // minHeight: screenSize <= 575 ? '17.6px' : '',
                  color: `rgba(${theme === "dark" ? "var(--theme-dark-tertiary), 0.8" : "var(--theme-light-tertiary), 0.75"})`,
                  marginTop: screenSize <= 991 ? "2px" : "2px",
                }}
              >
                {data.request_status}
              </div>
            </div>
          </div>
        </div>
        
        {/* {action ? ( */}
        <div className='col-2 col-sm-auto p-0 px-1'>
          <div className=''>
            <div
              className='text-start pe-4'
              style={{
                minWidth: screenSize >= 992 ? "80px" : screenSize >= 576 && screenSize <= 991 ? "60px" : "",
                display: "inline-block",
              }}
            >
              <div
                className='text-end'
                style={{
                  // fontSize: screenSize <= 991 ? "0.6rem" : "0.74rem",
                  fontSize: screenSize >= 992 ? "0.7rem" : screenSize <= 991 && screenSize >= 576 ? "0.7rem" : "0.6rem",
                  fontWeight: "400",
                  color: `rgba(${theme === "dark" ? "var(--theme-dark-tertiary)" : "var(--theme-light-tertiary)"},0.5)`,
                  letterSpacing: ".05em",
                }}
              >
                {t("requests.item.action")}
              </div>
              <div
                className='d-flex align-items-center justify-content-end flex-nowrap column-gap-2'
                style={{
                  // fontSize: screenSize <= 991 ? "1.1rem" : "1.14rem",
                  fontSize: screenSize >= 992 ? "1.15rem" : screenSize <= 991 && screenSize >= 576 ? "1.15rem" : "1.5rem",
                  fontWeight: "400",
                  lineHeight: "1.1",
                  color: `rgba(${theme === "dark" ? "var(--theme-dark-tertiary), 0.8" : "var(--theme-light-tertiary), 0.75"})`,
                  marginTop: screenSize <= 991 ? "2px" : "2px",
                }}
              >
                  {["saleofunit", "redemptionofunits"].includes(data.request_type) ? (
                    <button className='btn m-0 p-0 border-0' type='button' onClick={() => toggleProofModal(data)}>
                      <EyeAltIcon
                        width={screenSize >= 576 ? 26 : 22}
                        height={screenSize >= 576 ? 26 : 22}
                        color={theme === "light" ? "var(--theme-light-primary)" : "var(--theme-light-secondary)"}
                      />
                    </button>
                  ) : ''}
                {/* {data.request_type === "conversionofunits" ? ( */}
                  <button className='btn m-0 p-0 border-0' type='button' onClick={() => toggleDetailsModal(data)}>
                    <ReceiptIcon width={24} height={24} color={theme === "light" ? "var(--theme-light-primary)" : "var(--theme-light-secondary)"} />
                  </button>
                {/* ) : ( */}
                {/* )} */}
                {/* {data.request_type === "redemptionofunits" ? (
                  <button className='btn m-0 p-0 border-0' type='button' onClick={() => {}}>
                    <ReceiptIcon width={24} height={24} color={theme === "light" ? "var(--theme-light-primary)" : "var(--theme-light-secondary)"} />
                  </button>
                ) : (
                  ""
                )} */}
              </div>
            </div>
          </div>
        </div>
        {/* ) : ''} */}
      </div>
    </div>
  );
});

RequestItem.displayName = "RequestItem";

export default RequestItem;
